import React from 'react';

/**
 * AdminListCard — 어드민 목록 페이지 공통 카드 컴포넌트
 * 왼쪽 라벨 | 구분선 | 뱃지+제목+설명 | 오른쪽 액션
 *
 * @param {string} leftLabel - 왼쪽 영역 텍스트 (예: "5점", "예약")
 * @param {string} leftColor - 왼쪽 텍스트 색상 클래스 (default: 'text-mono-900')
 * @param {React.ReactNode} badges - 뱃지 영역
 * @param {string} title - 제목
 * @param {string} description - 설명 (line-clamp-2)
 * @param {React.ReactNode} checkbox - 체크박스 (SelectionCheckbox 등)
 * @param {React.ReactNode} actions - 오른쪽 버튼 영역
 * @param {function} onClick - 카드 클릭 핸들러
 */
export default function AdminListCard({ leftLabel, leftColor = 'text-mono-900', badges, title, description, checkbox, actions, onClick, className = '' }) {
  return (
    <div
      className={`flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-0 p-4 bg-white border border-mono-200 rounded-xl shadow-card ${onClick ? 'cursor-pointer hover:border-mono-300 hover:shadow-md transition-all' : ''} ${className}`}
      onClick={onClick}
    >
      {checkbox && <div className="shrink-0 sm:mr-3">{checkbox}</div>}
      <div className="flex sm:flex-col items-center gap-2 sm:gap-0 sm:w-20 shrink-0 text-center">
        <span className={`text-sm font-bold ${leftColor}`}>{leftLabel}</span>
      </div>
      <div className="hidden sm:block w-px h-14 bg-mono-100 mx-4 shrink-0" />
      <div className="flex-1 min-w-0 space-y-1.5">
        {badges && <div className="flex flex-wrap items-center gap-2">{badges}</div>}
        <p className="text-sm font-bold text-mono-900">{title}</p>
        {description && <p className="text-2sm text-mono-500 line-clamp-2 leading-relaxed">{description}</p>}
      </div>
      {actions && <div className="flex gap-2 sm:ml-4 shrink-0">{actions}</div>}
    </div>
  );
}
